module.exports = "<app-discount-group-list></app-discount-group-list>\r\n"